import React from "react";
import { Route, Switch } from "react-router-dom";
import Financial from "./financial/index";
import CRM from "./crm/index";
import Company from "./company/index";
import User from "./user/index";
import Donation from "./donation/index";
import Assets from "./assets/index";
import Project from "./project/index";
import Settings from "./settings/index";
import Vendors from "./vendors/index";
import HRM from "./hrm/index";
import Dashboard from "./dashboard/index";
import Profile from "./profile/index";
import ArAp from "./arap/index";
import Fleet from "./fleet/index";
import Purchase from "./purchase/index";
import Document from "./document/index";

import ExportToWord from "../util/gendocs";
import Product from "./products";
import Entries from "./entries";
import Sales from "./sales";
import Offering from "./offering";
import EMS_HRM from "./ems_hrm";
import asyncComponent from "../util/asyncComponent";
import { CisUI } from "../util/CISUI";
const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      {CisUI().getUserInfo("id") > 0 ? (
        <>
          <Route
            path={`${match.url}changelayout`}
            component={asyncComponent(() => import("../containers/Customizer"))}
          />
          <Route path={`${match.url}main`} component={Dashboard} />
          <Route path={`${match.url}accounts`} component={Financial} />
          <Route path={`${match.url}crm`} component={CRM} />
          <Route path={`${match.url}company`} component={Company} />
          <Route path={`${match.url}user`} component={User} />
          <Route path={`${match.url}donation`} component={Donation} />
          <Route path={`${match.url}assets`} component={Assets} />
          <Route path={`${match.url}vendor`} component={Vendors} />
          <Route path={`${match.url}hrm`} component={HRM} />
          <Route path={`${match.url}purchase`} component={Purchase} />
          <Route path={`${match.url}project`} component={Project} />
          <Route path={`${match.url}settings`} component={Settings} />
          <Route path={`${match.url}docs`} component={ExportToWord} />
          <Route path={`${match.url}document`} component={Document} />
          <Route path={`${match.url}profile`} component={Profile} />
          <Route path={`${match.url}stores`} component={Product} />
          <Route path={`${match.url}entries`} component={Entries} />
          <Route path={`${match.url}arap`} component={ArAp} />
          <Route path={`${match.url}sales`} component={Sales} />
          <Route path={`${match.url}fleet`} component={Fleet} />
          <Route path={`${match.url}offering`} component={Offering} />
          <Route path={`${match.url}ems_hrm`} component={EMS_HRM} />
        </>
      ) : (
        <></>
      )}
    </Switch>
  </div>
);

export default App;
